module.exports = function() {
  return new Worker(__webpack_public_path__ + "14e648dc57b5daa0e960.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/react-pdf/dist/pdf.worker.entry.js
// module id = 1216
// module chunks = 1